import { ModalDetalheProdutoProvider } from "../ModalDetalheProdutoContext";
import Listagem from "./Listagem";

export default function ListarTodas() {
    return(
        <ModalDetalheProdutoProvider>
            <Listagem />
        </ModalDetalheProdutoProvider>
    )
}